// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3kZ_Z","content":"RecentSearches_content__3M6ZX"};